// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"2d50d1c2","337":"c4632b3c"}[chunkId] + ".chunk.js";
};